import React, {Component} from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody
} from 'reactstrap'
import StudentHeader from './StudentHeader';
import ShowRecords from './ShowRecords';

const R = require('ramda')

class ViewByStudent extends Component {

  constructor(props) {
    super(props);
    this.callback = null;
    this.state = {
      student: null,
      records: null,
      schedules: null
    }
  }

  componentWillMount() {
    let _this = this;
    let stuID = this.props.user.email.substring(0, this.props.user.email.indexOf('@'));
    this.props.dispatch('DATA:SELECTED_STUID', stuID);
    this.cancelCallbacks();

    // Get the student
    this.props.db.ref('students/'+stuID).on('value', snapshot => {
      _this.setState({student: snapshot.val()})
    })

    // Get the LOP records
    this.props.db.ref('records/'+stuID).on('value', snapshot => {
      let recordObjs = R.mapObjIndexed((val, key) => {
        val.key = key;
        return val
      }, snapshot.val())
      _this.setState({records: R.values(recordObjs)})
    })

    // Get the schedules
    this.props.db.ref('schedules/'+stuID).on('value', snapshot => {
      _this.setState({schedules: R.values(snapshot.val())})
    })

    // Save the stuID so we can cancel the Firebase callbacks later
    this.callback = stuID;
  }

  cancelCallbacks() {
    if (this.callback) {
      this.props.db.ref('students/'+this.callback).off();
      this.props.db.ref('records/'+this.callback).off();
      this.props.db.ref('schedules/'+this.callback).off();
    }
    this.callback = null;
  }

  onStudentSelected(evt) {
    let _this = this;
    let stuID = (evt) ? evt.currentTarget.getAttribute('data-key') : this.props.selectedStuID;
    this.props.dispatch('DATA:SELECTED_STUID', stuID);
    this.cancelCallbacks();

    // Get the student
    this.props.db.ref('students/'+stuID).on('value', snapshot => {
      _this.setState({student: snapshot.val()})
    })

    // Get the LOP records
    this.props.db.ref('records/'+stuID).on('value', snapshot => {
      let recordObjs = R.mapObjIndexed((val, key) => {
        val.key = key;
        return val
      }, snapshot.val())
      _this.setState({records: R.values(recordObjs)})
    })

    // Get the schedules
    this.props.db.ref('schedules/'+stuID).on('value', snapshot => {
      _this.setState({schedules: R.values(snapshot.val())})
    })

    // Save the stuID so we can cancel the Firebase callbacks later
    this.callback = stuID;
  }

  componentWillUnmount() {
    this.cancelCallbacks();
  }

  render() {
    return (
      <div>
        <Row className="master-detail-top-separator">
          <Col md={7}>
            <Card>
              <CardHeader>
                <StudentHeader student={this.state.student}
                               schedules={this.state.schedules}
                               user={this.props.user}
                               db={this.props.db} />
              </CardHeader>
              <CardBody>
                {
                  (this.state.student) ?
                    <ShowRecords student={this.state.student}
                                 records={this.state.records}
                                 schedule={this.state.schedules}
                                 reasons={this.props.reasons}
                                 user={this.props.user}
                                 db={this.props.db} /> : null
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }

}

export default ViewByStudent



// WEBPACK FOOTER //
// ./src/views/ViewByStudent.js